import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import {
  authSelector,
  confidentialSelector,
  employeeSelector,
  employeeLevelsSelector,
  lobSelector,
  companySelector,
  positionSelector,
} from './../../../selectors'
import { confidentialAction } from './../../../actions/'
import ConfidentialForm from '../../../components/confidential'
import CustomModalMessage from '../../../components/modal-message'

class EditConfidential extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emp_code: '',
      user_id: '',
      name: '',
      emp_level: '',
      emp_level_id: '',
      lob_name: '',
      salary: '',
      position_name: '',
      start_date: '',
      end_date: '',
      other_income: '',
      company_name: '',
      is_active: true,
      edit: false,
      id: '',
      activeTab: '1',
      isOK: false,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.handlePosition = this.handlePosition.bind(this)
    this.handleLevel = this.handleLevel.bind(this)
    this.findEmployeeInfo = this.findEmployeeInfo.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }
  componentDidMount() {
    if (_.get(this.props, 'edit.edit')) {
      this.props.getConfidential(_.get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'confidentialGet')) {
      this.setState({
        user_id: _.get(nextProps, 'confidentialGet.user_id'),
        position_id: _.get(nextProps, 'confidentialGet.position_id'),
        emp_level_id: _.get(nextProps, 'confidentialGet.emp_level_id'),
        salary: _.get(nextProps, 'confidentialGet.salary'),
        start_date: _.get(nextProps, 'confidentialGet.start_date') ? moment(_.get(nextProps, 'confidentialGet.start_date')).format('YYYY-MM-DD') : '',
        end_date: _.get(nextProps, 'confidentialGet.end_date') ? moment(_.get(nextProps, 'confidentialGet.end_date')).format('YYYY-MM-DD') : '',
        other_income: _.get(nextProps, 'confidentialGet.other_income'),
        is_active: _.get(nextProps, 'confidentialGet.is_active'),
        isOK: false,
      })
      this.props.resetGetConfidential()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({ id: _.get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getConfidential(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetConfidential()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleDelete() {
    this.deactivateConfidential()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  deactivateConfidential() {
    this.props.deactivateConfidential(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  handlePosition(e) {
    this.setState({
      position: e,
      position_id: e.position_code,
    })
  }
  handleLevel(e) {
    this.setState({
      emp_level: e,
      emp_level_id: e.level_code,
    })
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      this.props.editConfidential(
        _.get(this.state, 'id'),
        {
          emp_level_id: this.state.emp_level_id,
          salary: this.state.salary,
          other_income: this.state.other_income,
          start_date: moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  findPositionName(id) {
    const positions = _.get(this.props, 'positionList')
    for (let i = 0; i < positions.length; i++) {
      if (positions[i]._id === id) {
        return positions[i].name
      }
    }
    return ''
  }
  findLevelName(id) {
    const levels = _.get(this.props, 'levelList')
    for (let i = 0; i < levels.length; i++) {
      if (levels[i]._id === id) {
        return levels[i].name
      }
    }
    return ''
  }
  findLOBName(id) {
    const lobs = _.get(this.props, 'lobList')
    for (let i = 0; i < lobs.length; i++) {
      if (lobs[i]._id === id) {
        return lobs[i].name
      }
    }
    return ''
  }
  findCompanyName(id) {
    const companys = _.get(this.props, 'companyList')
    for (let i = 0; i < companys.length; i++) {
      if (companys[i]._id === id) {
        return companys[i].name
      }
    }
    return ''
  }
  findEmployeeInfo() {
    const employees = _.get(this.props, 'employeeList')
    const user_id = _.get(this.props, 'confidentialGet').user_id
    for (let i = 0; i < employees.length; i++) {
      if (employees[i]._id === user_id) {
        this.setState({
          emp_code: employees[i].emp_code,
          name: `${employees[i].first_name} ${employees[i].last_name}`,
          lob_name: this.findLOBName(employees[i].lob_id),
          company_name: this.findCompanyName(employees[i].company_id),
          position_name: this.findPositionName(employees[i].position_id),
          isOK: true,
        })
        break
      }
    }
  }

  render() {
    /* eslint no-underscore-dangle: 0 */
    if (_.get(this.props, 'confidentialGet') &&
    _.get(this.props, 'levelList') &&
    _.get(this.props, 'lobList') &&
    _.get(this.props, 'companyList') &&
    _.get(this.props, 'positionList') &&
    !_.get(this.state, 'isOK')) {
      this.findEmployeeInfo()
    }
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      <div>
        {
          _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmDiscard' &&
          <CustomModalMessage
            hide={ this.props.cancelDiscard }
            show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
        }
        <ConfidentialForm
          edit={ this.state.edit }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handlePosition={ this.handlePosition }
          handleLevel={ this.handleLevel }
          employee_list={ this.props.employeeList }
          position_list={ this.props.positionList }
          emp_level_list={ this.props.levelList }
          confidential_group={ this.props.confidential_group }
          emp_code={ this.state.emp_code }
          name={ this.state.name }
          user_id={ this.state.user_id }
          emp_level={ this.state.emp_level }
          emp_level_id={ this.state.emp_level_id }
          lob_name={ this.state.lob_name }
          company_name={ this.state.company_name }
          position_name={ this.state.position_name }
          salary={ this.state.salary }
          other_income={ this.state.other_income }
          start_date={ this.state.start_date }
          end_date={ this.state.end_date }
          is_active={ this.state.is_active }
          handleInput={ this.handleInput }
          button={ button }
          confrim={ _.get(this.props, 'confirm') }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

EditConfidential.propTypes = {
  editConfidential: PropTypes.func.isRequired,
  getConfidential: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  resetGetConfidential: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  confidentialGet: confidentialSelector.getGetConfidentialData,
  // confidentialData: confidentialSelector.getListConfidential,
  employeeList: employeeSelector.getListUser,
  lobList: lobSelector.getListLOB,
  levelList: employeeLevelsSelector.getListEmployeeLevels,
  companyList: companySelector.getListCompany,
  positionList: positionSelector.getListPosition,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  getConfidential: confidentialAction.getConfidentialByID,
  resetGetConfidential: confidentialAction.resetGetConfidential,
  editConfidential: confidentialAction.editConfidential,
  deactivateConfidential: confidentialAction.deactivateConfidential,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditConfidential)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/confidential/edit/index.js